/**
 * Canonical TanStack Query keys for enterprise-connector management.
 *
 * Single source so cache invalidations across components stay coherent.
 * Each tuple is suffixed with the ``conn_id`` so per-connection rows
 * never collide with the per-capability ``connectorsListKey``.
 */

export const enterpriseSchemaKey = (connId: string) => ["enterprise", "schema", connId] as const;

export const enterpriseProfilingKey = (connId: string) =>
  ["enterprise", "profiling", connId] as const;

export const enterpriseBusinessContextKey = (connId: string) =>
  ["enterprise", "business-context", connId] as const;

export const enterpriseExamplesKey = (connId: string) =>
  ["enterprise", "examples", connId] as const;

export const enterpriseSampleColumnKey = (connId: string, objectName: string, column: string) =>
  ["enterprise", "sample-column", connId, objectName, column] as const;

export const enterpriseSampleRowsKey = (connId: string, objectName: string) =>
  ["enterprise", "sample-rows", connId, objectName] as const;
